import React, { Component } from 'react';
import { array, bool, func, shape, string } from 'prop-types';

import { connect } from 'react-redux';

import EsmsModal from '../../components/EsmsModal';
import CancelButton from '../../components/CancelButton';
import ConfirmButton from '../../components/ConfirmButton';

import { deleteProfiles } from '../../actions/profileActions';
import {
    clearErrors,
    enqueueSnackbar
} from '../../actions/applicationMessageActions';

import classes from './DeleteProfileModal.module.css';

class DeleteProfileModal extends Component {
    static defaultProps = {
        clearErrors:    () => {},
        deleteProfiles: () => {},
        close:          () => {},
        open:           false
    };

    static propTypes = {
        clearErrors: func,
        companyInfo: shape({
            companyId: string.isRequired
        }),
        deleteProfiles: func,
        profiles:       array.isRequired,
        close:          func,
        open:           bool
    };

    handleDelete = async () => {
        const { companyInfo: { companyId }, profiles } = this.props;
        try {
            const allDeleted =
                await this.props.deleteProfiles(companyId, profiles);
            if (allDeleted) {
                const parent = document.getElementById('table');
                let children = parent.getElementsByClassName('k-grid-content k-virtual-content');
                children[0].scrollTop = 0;

                this.handleClose();
            }
        } catch (error) {
            this.props.enqueueSnackbar(
                `An error has occurred: ${error.message}`,
                'error'
            );
        }
    }

    handleClose = () => {
        this.props.clearErrors();
        this.props.close();
    }

    render() {
        let { errors, open, profiles } = this.props;

        return (
            <EsmsModal
                errors={errors}
                imgSrc="/assets/images/profilesIconColor.svg"
                open={open}
                onClose={this.handleClose}
                title={`Delete ${profiles.length} Profile(s)`}
            >
                <p>
                    You must either delete all Devices or assign a different Profile for all of the Devices using these Profiles before they can be deleted.
                </p>
                <p>
                    Are you sure you want to delete these profiles:
                </p>
                <ul>
                    {profiles.map(({ id, name }) => (
                        <li key={id}>
                            {name}
                        </li>
                    ))}
                </ul>
                <div className={classes.buttonContainer}>
                    <CancelButton cancel={this.handleClose} />
                    <ConfirmButton
                        label="confirm"
                        type="button"
                        confirm={this.handleDelete}
                    />
                </div>
            </EsmsModal>
        );
    }
}

const mapStateToProps = ({ companyInfo, messages: { errors } }) => ({
    companyInfo,
    errors
});

const mapDispatchToProps = {
    clearErrors,
    deleteProfiles,
    enqueueSnackbar
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteProfileModal);
